(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-product-highlight"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-pd-product-section]');

    sections.forEach(function (section) {
      var mainImage = section.querySelector('[data-pd-main-image] img, [data-pd-main-image] .pd-product__image--placeholder');

      var thumbs = section.querySelectorAll('[data-pd-thumb]');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
          var fullSrc = thumb.getAttribute('data-full-src');
          // Re-look-up the image element fresh instead of relying on the
          // `mainImage` reference captured at page load, in case it was
          // swapped out from under us.
          var currentMainImage = section.querySelector('[data-pd-main-image] img');
          if (currentMainImage && fullSrc) {
            currentMainImage.src = fullSrc;
            currentMainImage.srcset = '';
          }
        });
      });

      var qtyInput = section.querySelector('[data-pd-qty-input]');
      var qtyMinus = section.querySelector('[data-pd-qty-minus]');
      var qtyPlus = section.querySelector('[data-pd-qty-plus]');
      if (qtyInput && qtyMinus && qtyPlus) {
        qtyMinus.addEventListener('click', function () {
          var value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
          qtyInput.value = value;
        });
        qtyPlus.addEventListener('click', function () {
          var value = (parseInt(qtyInput.value, 10) || 1) + 1;
          qtyInput.value = value;
        });
      }

      var priceEl = section.querySelector('[data-pd-price]');
      var comparePriceEl = section.querySelector('[data-pd-compare-price]');
      var discountBadgeEl = section.querySelector('[data-pd-discount-badge]');
      var stickyPriceEl = section.querySelector('[data-pd-sticky-price]');
      var addBtn = section.querySelector('[data-pd-add-btn]');
      var addBtnText = section.querySelector('[data-pd-add-btn-text]');
      var stickyAddBtn = section.querySelector('.pd-sticky-bar__button');
      var radios = section.querySelectorAll('[data-pd-variant-radio]');

      var stockBar = section.querySelector('[data-pd-stock-bar]');
      var stockMessageEl = section.querySelector('[data-pd-stock-message]');
      var stockFillEl = section.querySelector('[data-pd-stock-fill]');
      var stockTemplate = stockBar ? stockBar.getAttribute('data-message-template') || '' : '';
      var stockThreshold = stockBar ? parseInt(stockBar.getAttribute('data-threshold'), 10) || 10 : 10;
      var stockMax = stockBar ? parseInt(stockBar.getAttribute('data-max'), 10) || 100 : 100;

      var updateStockBar = function (variant) {
        if (!stockBar) return;
        var qty = variant ? parseInt(variant.inventory_quantity, 10) : NaN;
        var managed = variant && variant.inventory_management === 'shopify';
        if (managed && !isNaN(qty) && qty > 0 && qty <= stockThreshold) {
          var pct = Math.min(100, Math.round((qty / stockMax) * 100));
          if (stockMessageEl) stockMessageEl.textContent = stockTemplate.replace('{stock_number}', qty);
          if (stockFillEl) stockFillEl.style.width = pct + '%';
          stockBar.hidden = false;
          stockBar.classList.remove('is-hidden');
        } else {
          stockBar.hidden = true;
          stockBar.classList.add('is-hidden');
        }
      };

      radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (!radio.checked) return;
          var available = radio.getAttribute('data-available') === 'true';
          var priceCents = radio.getAttribute('data-price');
          updateStockBar({
            inventory_quantity: radio.getAttribute('data-inventory-quantity'),
            inventory_management: radio.getAttribute('data-inventory-management')
          });
          var comparePriceCents = parseInt(radio.getAttribute('data-compare-price'), 10) || 0;
          if (priceCents && window.Shopify && window.Shopify.formatMoney && window.theme && window.theme.moneyFormat) {
            var formatted = window.Shopify.formatMoney(priceCents, window.theme.moneyFormat);
            if (priceEl) priceEl.textContent = formatted;
            if (stickyPriceEl) stickyPriceEl.textContent = formatted;
            if (comparePriceCents > parseInt(priceCents, 10)) {
              if (comparePriceEl) {
                comparePriceEl.textContent = window.Shopify.formatMoney(comparePriceCents, window.theme.moneyFormat);
                comparePriceEl.hidden = false;
              }
              if (discountBadgeEl) {
                var pct = Math.round(((comparePriceCents - priceCents) / comparePriceCents) * 100);
                discountBadgeEl.textContent = '-' + pct + '%';
                discountBadgeEl.hidden = false;
              }
            } else {
              if (comparePriceEl) comparePriceEl.hidden = true;
              if (discountBadgeEl) discountBadgeEl.hidden = true;
            }
          }
          if (addBtn) addBtn.disabled = !available;
          if (stickyAddBtn) stickyAddBtn.disabled = !available;
          if (addBtnText) {
            addBtnText.textContent = available
              ? addBtnText.getAttribute('data-add-label') || addBtnText.textContent
              : addBtnText.getAttribute('data-sold-out-label') || addBtnText.textContent;
          }
        });
      });

      // Multi-option (Color + Size, etc.) path. Only runs when the section
      // actually rendered the JSON variants blob above, i.e. only for
      // products that have a real Color option. Products with just Size
      // never reach this code at all -- they're handled entirely by the
      // radios.forEach block above, unchanged.
      var variantsScript = section.querySelector('[data-pd-variants-json]');
      if (variantsScript) {
        var sectionVariants = JSON.parse(variantsScript.textContent);
        var variantsInventoryScript = section.querySelector('[data-pd-variants-inventory-json]');
        if (variantsInventoryScript) {
          var variantsInventory = JSON.parse(variantsInventoryScript.textContent);
          sectionVariants.forEach(function (variant) {
            var inv = variantsInventory[variant.id];
            if (inv) {
              variant.inventory_quantity = inv.inventory_quantity;
              variant.inventory_management = inv.inventory_management;
            }
          });
        }
        var variantIdInput = section.querySelector('[data-pd-variant-id]');
        var optionRadios = section.querySelectorAll('[data-pd-option-radio]');
        var colorNameEl = section.querySelector('[data-pd-color-name]');

        var findMatchingVariant = function () {
          var selected = [];
          optionRadios.forEach(function (radio) {
            if (radio.checked) {
              selected[parseInt(radio.getAttribute('data-option-position'), 10)] = radio.value;
            }
          });
          return sectionVariants.filter(function (variant) {
            return variant.options.length === selected.length && variant.options.every(function (val, i) {
              return val === selected[i];
            });
          })[0] || null;
        };

        var applyVariant = function (variant) {
          updateStockBar(variant);
          if (!variant) {
            if (addBtn) addBtn.disabled = true;
            if (stickyAddBtn) stickyAddBtn.disabled = true;
            if (addBtnText) addBtnText.textContent = addBtnText.getAttribute('data-sold-out-label') || 'Unavailable';
            return;
          }
          if (variantIdInput) variantIdInput.value = variant.id;
          if (window.Shopify && window.Shopify.formatMoney && window.theme && window.theme.moneyFormat) {
            var formatted = window.Shopify.formatMoney(variant.price, window.theme.moneyFormat);
            if (priceEl) priceEl.textContent = formatted;
            if (stickyPriceEl) stickyPriceEl.textContent = formatted;
            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
              if (comparePriceEl) {
                comparePriceEl.textContent = window.Shopify.formatMoney(variant.compare_at_price, window.theme.moneyFormat);
                comparePriceEl.hidden = false;
              }
              if (discountBadgeEl) {
                var pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
                discountBadgeEl.textContent = '-' + pct + '%';
                discountBadgeEl.hidden = false;
              }
            } else {
              if (comparePriceEl) comparePriceEl.hidden = true;
              if (discountBadgeEl) discountBadgeEl.hidden = true;
            }
          }
          if (addBtn) addBtn.disabled = !variant.available;
          if (stickyAddBtn) stickyAddBtn.disabled = !variant.available;
          if (addBtnText) {
            addBtnText.textContent = variant.available
              ? addBtnText.getAttribute('data-add-label') || addBtnText.textContent
              : addBtnText.getAttribute('data-sold-out-label') || addBtnText.textContent;
          }
          if (mainImage && mainImage.tagName === 'IMG' && variant.featured_image && variant.featured_image.src) {
            mainImage.src = variant.featured_image.src;
            mainImage.srcset = '';
          }
        };

        optionRadios.forEach(function (radio) {
          radio.addEventListener('change', function () {
            if (!radio.checked) return;
            if (radio.classList.contains('pd-product__color-input') && colorNameEl) {
              colorNameEl.textContent = radio.value;
            }
            if (radio.classList.contains('pd-product__color-input')) {
              var label = section.querySelector('label[for="' + radio.id + '"]');
              var fullSrc = label && label.getAttribute('data-full-src');
              if (fullSrc && mainImage && mainImage.tagName === 'IMG') {
                mainImage.src = fullSrc;
                mainImage.srcset = '';
              }
            }
            applyVariant(findMatchingVariant());
          });
        });

        // Some mobile browsers don't reliably fire the native label->input
        // "click passthrough" when the label wraps an <img> (as these color
        // swatches do), so drive the radio manually instead of depending on
        // that browser behavior.
        var colorLabels = section.querySelectorAll('.pd-product__color-label');
        colorLabels.forEach(function (label) {
          label.addEventListener('click', function (e) {
            e.preventDefault();
            var input = document.getElementById(label.getAttribute('for'));
            if (!input) return;
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
      }

      var stickyBar = section.querySelector('[data-pd-sticky-bar]');
      var addBtnAnchor = section.querySelector('[data-pd-add-btn]');
      if (stickyBar && addBtnAnchor && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              stickyBar.hidden = entry.isIntersecting;
            });
          },
          { rootMargin: '0px 0px -20% 0px' }
        );
        observer.observe(addBtnAnchor);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
